export default {
  addMediationApp (state, { mediation, app }) {
    if (!state.mediationList[mediation][app.key]) {
      state.mediationList[mediation][app.key] = app
    }
  }
}
